
import $ from 'jquery';
import Vue from 'vue';
import { Component, Inject, Prop } from 'vue-property-decorator';
import Toasted from 'vue-toasted';
import { TestEquipmentApiUiV2Client, TestEquipmentDevice, TestEquipmentTest } from '../../backend/backendapi';
import TestEquipmentTestEdit from './TestEquipmentTestEdit';
import State from '../State';
import Spinner from '../../util/Spinner';
import { handleError, initClient } from '../../../api';

Vue.use(Toasted, { duration: 2000 });

@Component({
  components: {
    Spinner,
    TestEquipmentTestEdit,
  },
})
export default class TestEquipmentTestEditModal extends Vue {
  @Prop({ default: true })
  editable!: boolean;

  @Inject({ from: 'state' })
  readonly state!: State;

  private readonly equipmentAPI = initClient(TestEquipmentApiUiV2Client);

  equipment: TestEquipmentDevice | null = null;
  test: TestEquipmentTest | null = null;
  newTestFiles: string[] = [];
  saving = false;

  get canSave(): boolean {
    return !!this.test.protocolNumber
        && !!this.test.testDate
        && !!this.test.testPerson
        && !!this.test.testSpecification
        && !!this.test.expectedError
        && !!this.test.error
        && !!this.test.grade;
  }

  public open(equipment: TestEquipmentDevice, test: TestEquipmentTest): void {
    this.equipment = equipment;
    this.test = test;
    this.newTestFiles.splice(0);
    $(this.$refs.modal!).modal('show');
  }

  public dismiss(): void {
    $(this.$refs.modal!).modal('hide');
    this.equipment = null;
    this.test = null;
    this.newTestFiles.splice(0);
  }

  async fileAdded(fileId: string): Promise<void> {
    if (!this.test) {
      return;
    }

    if (!this.test.id) {
      this.newTestFiles.push(fileId); //update media in save/create
    } else {
      try {
        const r = await this.equipmentAPI.linkTestMedia(this.test.testEquipmentId, this.test.id, fileId);
        this.$toasted.info(this.$t('txtSaved').toString());
        this.test.files.push(r!);
      } catch (err) {
        handleError(this.$toasted, this.$i18n, err);
      }
    }
  }

  async save(): Promise<void> {
    if (!this.test) {
      return;
    }

    this.saving = true;
    try {
      const testFinal = this.test;
      if (testFinal.id < 1) {
        const testFromServer = (await this.equipmentAPI.createTests(testFinal.testEquipmentId, [testFinal]))[0];

        //link files
        for (let i = 0; i < this.newTestFiles.length; i++) {
          const r = await this.equipmentAPI.linkTestMedia(testFromServer.testEquipmentId, testFromServer.id, this.newTestFiles[i]);
          testFinal.files.push(r!);
        }
      } else {
        await this.equipmentAPI.updateTest(testFinal.testEquipmentId, testFinal.id, testFinal);
      }

      this.$toasted.info(this.$t('txtSaved').toString());
      this.dismiss();
    } catch (err) {
      handleError(this.$toasted, this.$i18n, err);
    } finally {
      this.saving = false;
    }
  }
}
